import {
  gamesLocaleEn,
  gamesLocaleKa,
  type TGameLocaleContent,
  type TGamesLocale,
} from '@skillarea/locale-skillarea';
import {
  DEFAULT_LOCALE,
  normalizeLocale,
  type GameReturnDto,
} from '@skillarea/lib-shared';

const GAME_LOCALES: Record<string, TGamesLocale> = {
  en: gamesLocaleEn,
  ka: gamesLocaleKa,
};

type TGameLocaleSource = Pick<
  GameReturnDto,
  'slug' | 'name' | 'description' | 'rules'
>;

function resolveGameField(
  slug: string,
  field: keyof TGameLocaleContent,
  fallback: string,
  language: string,
): string {
  const resolvedLanguage = normalizeLocale(language) ?? DEFAULT_LOCALE;
  const languages = [resolvedLanguage, DEFAULT_LOCALE].filter(
    (lang, index, arr) => arr.indexOf(lang) === index,
  );

  for (const lang of languages) {
    const entry = GAME_LOCALES[lang]?.[slug];
    if (!entry || typeof entry !== 'object' || !(field in entry)) {
      continue;
    }

    const value = entry[field as keyof TGameLocaleContent];
    if (typeof value === 'string' && value.length > 0) {
      return value;
    }
  }

  return fallback;
}

export function resolveLocalizedGameContent(
  game: TGameLocaleSource,
  language: string,
): TGameLocaleContent {
  return {
    name: resolveGameField(game.slug, 'name', game.name, language),
    description: resolveGameField(
      game.slug,
      'description',
      game.description,
      language,
    ),
    rules: resolveGameField(game.slug, 'rules', game.rules, language),
  };
}
